import type { TransactionsReport } from 'model/TransactionsReport';

export enum TransactionsReportStatus {
    Initial = 'Initial',
    Getting = 'Getting',
    GettingSuccess = 'GettingSuccess',
    Error = 'Error'
}

export interface TransactionsReportState {
    report: TransactionsReport;
    status: TransactionsReportStatus;
    loading: boolean;
}

export const emptyTransactionsReport = (): TransactionsReport => ({
    meta: {
        page: 1,
        perPage: 10,
        totalCount: 0,
        totalPages: 1
    },
    totals: {
        grossSales: 0,
        discounts: 0,
        refunds: 0,
        netSales: 0,
        tax: 0,
        tip: 0,
        serviceCharges: 0,
        totalCollected: 0,
        fees: 0,
        netTotal: 0
    },
    rows: []
});

export const initialTransactionsReportState: TransactionsReportState = {
    report: emptyTransactionsReport(),
    status: TransactionsReportStatus.Initial,
    loading: false
};
